export default __webpack_public_path__ + "static/media/img-destaque.163e720c.png";